import { InvoiceStatusVariants, HistoryStatusVariants } from "./settings";

const invoiceStatusVariant = (key: string): any => InvoiceStatusVariants.find((item: any) => item.key === key)?.value;
const historyStatusVariant = (key: string): any => HistoryStatusVariants.find((item: any) => item.key === key)?.value;

export { invoiceStatusVariant, historyStatusVariant };
